<template>
  <fieldset :disabled="disabled">
    <b-card no-body>
      <!-- <b-card-header> Title </b-card-header> -->
      <b-card-body>
        <b-form novalidate>
          <h3>Dados Gerais</h3>
          <hr />
          <fieldset class="mb-3">
            <b-form-row>
              <b-col lg="6" md="6" sm="12">
                <b-form-group label="Nome" label-for="name">
                  <b-form-input
                    id="name"
                    v-model="form.name"
                    :state="validation.name"
                  />
                  <b-form-invalid-feedback v-if="$v.form.name.$invalid">
                    Informe um nome
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <b-form-group label="CNPJ" label-for="document">
                  <b-form-input
                    id="document"
                    v-model="form.document"
                    :state="validation.document"
                    data-mask="['dd.ddd.ddd/dddd-dd']"
                    pattern=".{18.18}"
                  />

                  <b-form-invalid-feedback v-if="$v.form.document.$invalid">
                    Informe um CNPJ válido
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-form-row>
          </fieldset>
          <h3>Endereço</h3>
          <hr />

          <fieldset class="mb-3">
            <AddressPartialForm
              v-model="form"
              :validation="{
                state: validation,
                $v
              }"
              :disabled="disabled"
            />
            <StatusInput
              v-model="form.status"
              :validation="validation.status"
              :invalid="$v.form.status.$invalid"
            />
          </fieldset>
          <h3>Configurações de Aluguel</h3>
          <hr />
          <fieldset class="mb-3">
            <b-form-row>
              <b-col sm="12" md="4">
                <b-form-group
                  label="Minutos de Tolerância"
                  label-for="toleranceMinutes"
                >
                  <b-form-input
                    id="toleranceMinutes"
                    v-model="form.toleranceMinutes"
                    :state="validation.toleranceMinutes"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12" md="4">
                <b-form-group
                  label="Taxa de Atraso (por minuto)"
                  label-for="delayFeePerMinute"
                >
                  <b-input-group prepend="R$">
                    <b-form-input
                      id="delayFeePerMinute"
                      v-model="delayFeePerMinuteInput"
                      v-money="{
                        decimal: ',',
                        thousands: '.',
                        precision: 2
                      }"
                      :state="validation.delayFeePerMinute"
                      @blur="syncDelayFeePerMinute"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="4">
                <b-form-group
                  label="Prazo de Cancelamento (minutos)"
                  label-for="cancellationDeadline"
                >
                  <b-form-input
                    id="cancellationDeadline"
                    v-model.number="form.cancellationDeadline"
                    type="number"
                    min="0"
                    :state="validation.cancellationDeadline"
                    placeholder="Ex: 5"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col sm="12" md="6" lg="4">
                <b-form-group label="Comissões" label-for="has-commissions">
                  <b-form-checkbox
                    id="has-commissions"
                    v-model="form.hasCommissions"
                    switch
                    :true-value="true"
                    :false-value="false"
                  >
                    Ativar sistema de comissões
                  </b-form-checkbox>
                  <small class="text-muted d-block">
                    Define se a loja utiliza o sistema de comissões.
                  </small>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="4">
                <b-form-group
                  label="Assinatura do aluguel"
                  label-for="has-rent-signature"
                >
                  <b-form-checkbox
                    id="has-rent-signature"
                    v-model="form.hasRentSignature"
                    switch
                    :true-value="true"
                    :false-value="false"
                  >
                    Ativar assinatura no aluguel
                  </b-form-checkbox>
                  <small class="text-muted d-block">
                    Define se o aluguel exige assinatura do cliente.
                  </small>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-collapse :visible="showRentTermsEditor" class="mt-2">
              <StoreRentTermsEditor :store-id="form.id" />
            </b-collapse>
            <small
              v-if="showRentTerms && form.hasRentSignature && !form.id"
              class="text-muted d-block mt-2"
            >
              Salve a loja para editar o termo de assinatura.
            </small>
          </fieldset>
          <h3>Configurações de Fotos</h3>
          <hr />
          <fieldset class="mb-3">
            <b-form-row>
              <b-col
                v-for="config in photoConfigs"
                :key="config.enabledKey"
                sm="12"
                md="6"
                lg="4"
              >
                <b-card no-body class="photo-config-card mb-3">
                  <b-card-body>
                    <b-form-group
                      :label="config.title"
                      :label-for="config.enabledKey"
                    >
                      <b-form-checkbox
                        :id="config.enabledKey"
                        v-model="form[config.enabledKey]"
                        switch
                        :true-value="true"
                        :false-value="false"
                        @change="onPhotoSystemChange(config)"
                      >
                        Ativo
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      label="Obrigatoriedade"
                      :label-for="config.requiredKey"
                      class="mb-0"
                    >
                      <b-form-radio-group
                        :id="config.requiredKey"
                        v-model="form[config.requiredKey]"
                        :disabled="!form[config.enabledKey]"
                        :options="requiredOptions"
                        stacked
                      />
                    </b-form-group>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-form-row>
          </fieldset>
        </b-form>
      </b-card-body>
    </b-card>

    <div class="mt-3 d-flex gap-1 justify-content-end">
      <b-button
        variant="outline-secondary"
        @click="handleCancel('StoresIndex')"
      >
        Cancelar
      </b-button>
      <b-button variant="success" @click="handleSubmit"> Salvar </b-button>
    </div>
  </fieldset>
</template>

<script>
import * as smask from '@/smask'
import { required } from 'vuelidate/lib/validators'
import withFormValidation from '@/mixins/withFormValidation'
import AddressPartialForm from '@/components/AddressPartialForm'
import StatusInput from '@/components/StatusInput'
import StoreRentTermsEditor from '@/components/Stores/StoreRentTermsEditor'
import { isValidCNPJ } from '@/helpers/validators'

export default {
  name: 'StoreForm',
  components: {
    AddressPartialForm,
    StatusInput,
    StoreRentTermsEditor
  },
  mixins: [
    withFormValidation({
      fields: [
        'name',
        'document',
        'address',
        'number',
        'county',
        'city',
        'state',
        'zipcode',
        'status'
      ]
    })
  ],
  props: {
    showRentTerms: { type: Boolean, default: false }
  },
  data() {
    return {
      delayFeePerMinuteInput: '',
      requiredOptions: [
        { text: 'Opcional', value: false },
        { text: 'Obrigatorio', value: true }
      ],
      photoConfigs: [
        {
          title: 'Fotos do deposito',
          enabledKey: 'hasDepositPhotos',
          requiredKey: 'isDepositPhotoRequired'
        },
        {
          title: 'Caderno de fechamento',
          enabledKey: 'hasCheckoutClosingNotebookPhotos',
          requiredKey: 'isCheckoutClosingNotebookPhotoRequired'
        },
        {
          title: 'Comprovante de maquininha',
          enabledKey: 'hasCheckoutMachineReceiptPhotos',
          requiredKey: 'isCheckoutMachineReceiptPhotoRequired'
        }
      ]
    }
  },
  validations: {
    form: {
      name: { required },
      document: { isValidCNPJ },
      address: { required },
      number: { required },
      county: { required },
      city: { required },
      state: { required },
      zipcode: { required },
      status: { required }
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    },
    showRentTermsEditor() {
      return Boolean(
        this.showRentTerms && this.form?.hasRentSignature && this.form?.id
      )
    }
  },
  watch: {
    'form.delayFeePerMinute': {
      handler(value) {
        const normalized = this.normalizeDelayFeePerMinute(value)
        if (this.delayFeePerMinuteInput !== normalized) {
          this.delayFeePerMinuteInput = normalized
        }
      },
      immediate: true
    }
  },
  mounted() {
    smask.prepareMaskInputs()
  },
  methods: {
    normalizeDelayFeePerMinute(value) {
      if (value === null || typeof value === 'undefined') return ''
      if (typeof value === 'number') {
        return value.toFixed(2).replace('.', ',')
      }
      return String(value)
    },
    syncDelayFeePerMinute() {
      const nextValue = this.delayFeePerMinuteInput
      if (this.form?.delayFeePerMinute === nextValue) return
      this.form = {
        ...this.form,
        delayFeePerMinute: nextValue
      }
    },
    onPhotoSystemChange(config) {
      if (!this.form[config.enabledKey]) {
        this.$set(this.form, config.requiredKey, false)
      }
    },
    handleSubmit() {
      this.syncDelayFeePerMinute()
      this.$v.form.$touch()
      !this.$v.form.$invalid && this.$emit('submit', this.form)
    }
  }
}
</script>
